import * as THREE from 'three';

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function lerpAngle(a: number, b: number, t: number): number {
  let diff = b - a;
  while (diff > Math.PI) diff -= Math.PI * 2;
  while (diff < -Math.PI) diff += Math.PI * 2;
  return a + diff * t;
}

export function degToRad(deg: number): number {
  return deg * (Math.PI / 180);
}

export function radToDeg(rad: number): number {
  return rad * (180 / Math.PI);
}

export function lerpVec3(
  out: THREE.Vector3,
  a: THREE.Vector3,
  b: THREE.Vector3,
  t: number,
): THREE.Vector3 {
  out.x = lerp(a.x, b.x, t);
  out.y = lerp(a.y, b.y, t);
  out.z = lerp(a.z, b.z, t);
  return out;
}

export function randomInCone(direction: THREE.Vector3, spreadDeg: number): THREE.Vector3 {
  const spreadRad = degToRad(spreadDeg);
  const u = Math.random();
  const v = Math.random();
  const theta = 2 * Math.PI * u;
  const phi = spreadRad * Math.sqrt(v);

  const right = new THREE.Vector3();
  const up = new THREE.Vector3();

  if (Math.abs(direction.y) < 0.99) {
    right.crossVectors(direction, new THREE.Vector3(0, 1, 0)).normalize();
  } else {
    right.crossVectors(direction, new THREE.Vector3(1, 0, 0)).normalize();
  }
  up.crossVectors(right, direction).normalize();

  const result = direction.clone();
  result.addScaledVector(right, Math.sin(phi) * Math.cos(theta));
  result.addScaledVector(up, Math.sin(phi) * Math.sin(theta));
  return result.normalize();
}

export function distanceSq(a: THREE.Vector3, b: THREE.Vector3): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  const dz = a.z - b.z;
  return dx * dx + dy * dy + dz * dz;
}
